import React, {Suspense} from "react";
import ReactDOM from "react-dom";
import {
    QueryClient,
    QueryClientProvider,
} from 'react-query'
import 'antd/dist/antd.css';
import "./sass/main.scss";
import {Forbidden, Profile, UserPanel} from "./app/components";
import Notifications from "./app/components/Notifications";


const queryClient = new QueryClient()

/* defined components list */
const Components = {
    'SignIn': React.lazy(() =>
        import(
            './app/components/SignIn'
        )
    ),
    'SignUp': React.lazy(() =>
        import(
            './app/components/SignUp'
        )
    ),
    'Forgot': React.lazy(() =>
        import(
            './app/components/Forgot'
            )
    ),
    'Recovery': React.lazy(() =>
        import(
            './app/components/Recovery'
            )
    ),

    'UserPanel': React.lazy(() =>
        import(
            './app/components/UserPanel'
        )
    ),

    'Forbidden': React.lazy(() =>
        import(
            './app/components/Forbidden'
        )
    ),

    'Notifications': React.lazy(() =>
        import(
            './app/components/Notifications'
        )
    ),
    'Profile': React.lazy(() =>
        import(
            './app/components/Profile'
        )
    ),

    'Console': React.lazy(() =>
        import(
            './app/components/Console'
        )
    ),
};

const LazyComponent = (props) => {

    if (!props.component) return null;

    const RenderComponent = Components[props.component] || null;

    if (RenderComponent === null) return null;

    return (
        <Suspense fallback={<div className={`loader component`} />}>
            <QueryClientProvider client={queryClient}>
                <RenderComponent {...props}/>
            </QueryClientProvider>
        </Suspense>
    );
}


window.addEventListener('DOMContentLoaded', function () {
    const storeComponents = [].slice.call(document.querySelectorAll('.cstore'));
    if (storeComponents && storeComponents.length > 0) {
        storeComponents.forEach(async cRoot => {
            let props = {};
            for(let i = 0; i < cRoot.attributes.length;i++) {
                let name = cRoot.attributes[i].nodeName || cRoot.attributes[i].name;
                if (name.indexOf('data-') + 1 > 0) {
                    props[name.replace('data-', '')] = cRoot.attributes[i].nodeValue;
                }
            }
            ReactDOM.render(<LazyComponent {...props}/>, cRoot)
        });
    }
});